const debtor_groups = {
	add_button: "Debiteurgroep toevoegen",
	add_dialog: {
		description: "Voeg een nieuwe debiteurgroep toe.",
		form: {
			description: "Beschrijving",
			name: "Naam",
		},
		title: "Debiteurgroep toevoegen",
	},
	delete_dialog: {
		description: "Wilt u debiteurgroep <strong>{{name}}</strong> echt verwijderen?",
		group_not_empty: {
			description:
				"Er zijn nog debiteuren gekoppeld aan deze debiteurgroep. Ontkoppel deze voordat u de productgroep verwijdert.",
			title: "Groep is niet leeg.",
		},
		title: "Debiteurgroep verwijderen",
	},
	disconnect_debtor: {
		description: "Wilt u debiteur <strong>{{name}}</strong> echt ontkoppelen?",
		success_alert: "Ontkoppelen van debiteur is gelukt!",
		title: "Debiteur ontkoppelen",
		unknown_alert: "Ontkoppelen van debiteur is niet gelukt! Probeert u het later opnieuw.",
	},
	duplicate_dialog: {
		description:
			"Voeg een nieuwe debiteurgroep toe met gebruik van de waarden van de geselecteerde debiteurgroep.",
		title: "Debiteurgroep toevoegen",
	},
	edit_dialog: {
		description: "Bewerk de geselecteerde debiteurgroep.",
		title: "Debiteurgroep bewerken",
	},
	status: {
		create: {
			success: "Debiteurgroep is toegevoegd!",
			unknown:
				"Er kan op dit moment geen debiteurgroep worden toegevoegd. Probeert u het later opnieuw.",
		},
		delete: {
			not_empty:
				"Debiteurgroep kan niet worden verwijderd, omdat er nog debiteuren aan gekoppeld zijn.",
			success: "Debiteurgroep is verwijderd!",
			unknown:
				"Er kan op dit moment geen debiteurgroep worden verwijderd. Probeert u het later opnieuw.",
		},
		edit: {
			success: "Debiteurgroep is gewijzigd!",
			unknown:
				"De gekozen debiteurgroep kan op dit moment niet worden gewijzigd. Probeert u het later opnieuw.",
		},
	},
	table: {
		description: "Omschrijving",
		details: "Details",
		name: "Debiteurgroep naam",
	},
	title: "Debiteurgroepen",
};

export default debtor_groups;
